import React from "react";
import {
  Page,
  Card,
  Layout,
  FormLayout,
  SkeletonDisplayText,
  SkeletonBodyText,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function FieldSkeletonForm(props) {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar
        title={t("common.loading")}
        breadcrumbs={[
          { content: t("settings.common.breadcrumbs.settings") },
          { content: t("settings.common.skeleton.customFields"), url: "/settings/fields" },
        ]}
      />
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <FormLayout>
              <SkeletonDisplayText />
              <SkeletonBodyText />
              <SkeletonDisplayText />
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
